module.exports = __webpack_public_path__ + "static/media/cyber_security_logo.52d5cbf5.png";